"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const parsers_1 = require("api/files/parsers");
const TranslationProvider_1 = require("src/providers/TranslationProvider");
const EmployeeFile_1 = tslib_1.__importDefault(require("../EmployeeFile"));
const MultiFiles = (props) => {
    const { translate } = (0, TranslationProvider_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: props.data.length === 0
            ?
                (0, jsx_runtime_1.jsx)(EmployeeFile_1.default, { userId: props.userId, employeeDocumentFilesHook: props.employeeDocumentFilesHook, name: props.name, fileType: props.fileType, file: { ...parsers_1.initialFile, type: props.type }, fileIndex: 0, data: props.data, mediaFileHook: props.mediaFileHook, placeholder: props.placeholder || translate('upload_file', 'ატვირთეთ ფაილი'), disabled: props.disabled })
            :
                props.data.map((item, itemIndex) => {
                    return ((0, jsx_runtime_1.jsx)(EmployeeFile_1.default, { file: item, userId: props.userId, employeeDocumentFilesHook: props.employeeDocumentFilesHook, name: props.name, fileType: props.fileType, data: props.data, fileIndex: itemIndex, mediaFileHook: props.mediaFileHook, disabled: props.disabled }, itemIndex));
                }) }));
};
exports.default = MultiFiles;
